<template>
  <!--<Plane :args="[100, 100]" :rotation="[0, 0, 0]" :position="[0, 0, 0]">
    <TresMeshStandardMaterial color="white" :metalness="0.5" :roughness="1" />
  </Plane>-->

  <TresGroup :position="[0, 6, 0]">
    <Suspense>
      <CanvasWorkItem
        v-for="(item, idx) in items"
        :key="idx"
        :position="[
          item.position == 1 ? hSpace : item.position == -1 ? -hSpace : 0,
          item.row * -vSpace,
          0
        ]"
        :rotation="[0, item.position == 1 ? -0.35 : item.position == -1 ? 0.35 : 0, 0]"
        :title="item.title"
        :scene="scene.scene"
        :texture="item.texture"
        :path="item.path"
        :delay="(idx + 1) * 0.3"
      />
    </Suspense>
    <Suspense>
      <CanvasWorkRow
        v-for="i in items[itemsLength - 1].row + 1"
        :key="i"
        :position="[i % 2 ? -6 * hSpace : -5 * hSpace, (i - 1) * -vSpace, 0]"
        :row="i - 1"
        :scene="sceneFrame.scene"
      />
    </Suspense>
  </TresGroup>
</template>
<script setup lang="ts">
import { useEventBus } from '@vueuse/core'
import { useGLTF } from '@tresjs/cientos'
const path = '/models/box.glb'
const pathFrame = '/models/box_frame.glb'
const scene = await useGLTF(path)
const sceneFrame = await useGLTF(pathFrame)

const props = defineProps<{
  data: WorkRecord[] | []
  animationTriggered: boolean
}>()

// console.log(scene, newScene)

const vSpace = ref(6)
const hSpace = ref(6)

// Array from DatoCMS with title, texture & path
const items = []

for (const item of props.data) {
  items.push({
    row: 0,
    position: 0,
    title: item.clients.map((client) => client.name).join(', ') as string,
    texture: item.imageSquared?.responsiveImage.src as string,
    path: item.slug as string
  })
}

// Set correct grid positions
let rowNum = -1
const positions = [0, -1, 1]
for (let i = 0; i < items.length; i++) {
  if ((i + 1) % 3) {
    rowNum++
  }
  items[i].row = rowNum
  items[i].position = positions[i % 3]
}
const itemsLength = ref(items.length)

const bus = useEventBus<boolean>('fire-works')

function fireWorks(event: boolean) {
  console.log(`${event}`)
}
const unsubscribe = bus.on(fireWorks)

onUnmounted(() => {
  unsubscribe()
})
</script>
